// Mock data for construction supply website

export const companyInfo = {
  name: "Nova Global Supply",
  tagline: "Premium Building Materials from Trusted Brands",
  description: "Importing quality construction supplies for Canadian builders, engineers, and inspectors. Specializing in Nova Faucets, VersaFlex CSST, and Nova Floors."
};

export const products = [
  {
    id: 1,
    name: "VersaDuct",
    brand: "VersaDuct",
    slug: "versaduct",
    shortDesc: "Return Air Joist Liner - Flame Retardant Corrugated Sheet",
    pricing: "Contact us for project pricing",
    fullDesc: "VersaDuct™ is a rigid, lightweight return-air joist liner designed for use in floor cavities and framed air pathways where return-air plenums are permitted by code. VersaDuct provides a consistent, clean alternative to traditional sheet metal panning materials for residential and light commercial HVAC return-air applications. Our grey corrugated polypropylene sheets feature the VersaDuct logo printed on one side, allowing flexible installation - visible in finished spaces or hidden in unfinished areas based on preference.",
    features: [
      "Exceeds Canadian Building Code requirements (FSI: 18, SDI: 35)",
      "Self-extinguishing flame-retardant polypropylene material",
      "Tested to CAN/ULC S102.2-19 standards",
      "VersaDuct logo printed on one side - install visible or hidden",
      "Lightweight and easy to cut and install",
      "No sharp edges compared to metal panning",
      "Moisture-resistant polymer construction",
      "Reduces vibration and noise vs. metal ducting"
    ],
    image: "https://customer-assets.emergentagent.com/job_novabuild-supply/artifacts/omy01cn0_file_00000000ff4871fd8fcc2ce391bca029%20%281%29.png",
    documents: [
      { name: "VersaDuct Product Data Sheet", type: "Spec Sheet", size: "1.2 MB", url: "https://customer-assets.emergentagent.com/job_novabuild-supply/artifacts/3jf1ijsf_VersaDuct%20Data%20Sheet%20Rev1.pdf" },
      { name: "Steiner Tunnel Test Results CAN/ULC S102.2-19", type: "Test Report", size: "2.1 MB", url: "/api/download/steiner-tunnel-test", downloadFilename: "Steiner_Tunnel_Test_Results.pdf" }
    ]
  },
  {
    id: 2,
    name: "Nova Faucets",
    brand: "Nova",
    slug: "nova-faucets",
    shortDesc: "Premium imported faucets from China",
    pricing: "Contact us for project pricing",
    fullDesc: "Nova brand faucets combine quality craftsmanship with competitive pricing. Our extensive catalog includes kitchen, bathroom, and commercial faucets designed to meet Canadian plumbing standards.",
    features: [
      "CSA certified for Canadian installations",
      "Durable brass construction",
      "Wide range of finishes available",
      "Comprehensive warranty coverage",
      "Compatible with standard installations"
    ],
    image: "https://customer-assets.emergentagent.com/job_novabuild-supply/artifacts/s7p6unfb_image.png",
    documents: [
      { name: "Nova Faucets Product Catalog", type: "Catalog", size: "2.4 MB" },
      { name: "Installation Manual", type: "Manual", size: "1.1 MB" },
      { name: "Technical Specifications", type: "Spec Sheet", size: "800 KB" },
      { name: "Warranty Information", type: "Document", size: "450 KB" }
    ]
  },
  {
    id: 3,
    name: "VersaFlex CSST",
    brand: "Just Link",
    slug: "versaflex-csst",
    shortDesc: "Corrugated Stainless Steel Tubing by Just Link",
    pricing: "Contact us for project pricing",
    fullDesc: "VersaFlex by Just Link is a premium corrugated stainless steel tubing (CSST) system designed for natural gas and propane distribution. Engineered for safety and ease of installation in residential and commercial applications.",
    features: [
      "CSA certified gas distribution system",
      "Flexible stainless steel construction",
      "Faster installation than traditional black pipe",
      "Reduced labor costs",
      "Complete fittings and accessories available"
    ],
    image: "https://customer-assets.emergentagent.com/job_novabuild-supply/artifacts/kcyco7ob_CSST%20picture.jpg",
    documents: [
      { name: "Installation Guide", type: "Manual", size: "2.8 MB", url: "https://customer-assets.emergentagent.com/job_novabuild-supply/artifacts/p50h5z5e_Versa%20flex%20Installation%20Manual.pdf" },
      { name: "CSA Listing Certificate", type: "Certificate", size: "1.2 MB", url: "https://customer-assets.emergentagent.com/job_novabuild-supply/artifacts/3rxzc1ab_CSST%20CSA%20CERTIFICATE.pdf" }
    ]
  },
  {
    id: 4,
    name: "Nova Floors",
    brand: "Nova",
    slug: "nova-floors",
    shortDesc: "Premium flooring solutions",
    pricing: "Contact us for project pricing",
    fullDesc: "Nova Floors offers a comprehensive range of high-quality flooring materials suitable for residential and commercial projects. Our products meet Canadian building codes and are backed by industry-leading warranties.",
    features: [
      "Wide selection of styles and finishes",
      "Durable and long-lasting materials",
      "Easy installation systems",
      "Competitive pricing",
      "Suitable for various applications"
    ],
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&q=80",
    documents: [
      { name: "Nova Floors Product Catalog", type: "Catalog", size: "4.1 MB" },
      { name: "Installation Instructions", type: "Manual", size: "1.9 MB" },
      { name: "Technical Data Sheets", type: "Spec Sheet", size: "1.2 MB" },
      { name: "Maintenance Guide", type: "Guide", size: "750 KB" }
    ]
  }
];

export const testimonials = [
  {
    name: "Mike Chen",
    role: "General Contractor",
    company: "Chen Construction Ltd.",
    text: "Nova Global Supply's documentation and technical support have been invaluable. Inspectors appreciate the detailed spec sheets."
  },
  {
    name: "Sarah Thompson",
    role: "Project Engineer",
    company: "Thompson Engineering",
    text: "The VersaFlex CSST system has significantly reduced our installation time while maintaining the highest safety standards."
  },
  {
    name: "Robert Martinez",
    role: "Building Inspector",
    company: "City of Toronto",
    text: "All documentation is readily available and products consistently meet code requirements. A reliable supplier."
  }
];

export const features = [
  {
    title: "Canadian Code Compliant",
    description: "All products meet or exceed Canadian building and safety codes"
  },
  {
    title: "Complete Documentation",
    description: "Comprehensive catalogs, spec sheets, and installation manuals"
  },
  {
    title: "Technical Support",
    description: "Expert assistance for contractors, engineers, and inspectors"
  },
  {
    title: "Quality Assurance",
    description: "Rigorous testing and certification for all product lines"
  }
];